  function ARI_addToCart(qs) {
    
    
    if (!qs || qs.length == 0) {
      
      alert('This product cannot be found.');
      return;
    }
    
    var qsParts = qs.split('&');
    var sku = '';
    var price = 0;
    var qty = 1;
    var partInfo = [];
    
    
        if (console && console.log) {
          console.log(qs);
        }
    
    for (i=0; i < qsParts.length; i++) {
      var qsPart = qsParts[i];
      if (qsPart.indexOf('=') >= 0) {
        var qsKeyValue = qsPart.split('=');
        var key = decodeURIComponent(qsKeyValue[0]).trim();
        var value = decodeURIComponent(qsKeyValue[1]).trim();
        if (key == 'arisku') {
          sku = value;
        } else if (key == 'ariprice') {
          price = value;
        } else if (key == 'ariqty') {
          qty = value;
        } else if (key == 'arireturnurl') {
          var returnUrl = decodeURIComponent(value).trim();

          // break up the returnUrl to get the category names
          var returnUrlSplit = returnUrl.split("#");
          if (returnUrlSplit.length == 2) {
            var pathSplit = returnUrlSplit[1].split('/');
            if (pathSplit.length >= 4) {
              partInfo.push(pathSplit[2]);
              partInfo.push(pathSplit[3]);
            }
          }
        }

        if (console && console.log) {
          console.log(key, value);
        }

      }
    }
    
    if (!sku || sku == '') {
      alert('This product sku cannot be found.');
      return;
    }
    
//    if (console && console.log) {
//    	console.log('ARI_addToCart:' + sku);
//    }
    
    updateLoadingIndicatorMessage("Currently searching inventory for part number " + sku + ", please wait");
    showLoadingIndicator();
    showLoadingOverlay();

    window.setTimeout(function(){
      
      findProductBySku(sku, price, partInfo, qty);
      
    }, 1500);
    
    return false;
  }

  
/* Open when someone clicks on the span element */
function showLoadingIndicator() {
    $("#partsAddToCartLoadingIndicator").removeClass("hide");
}

/* Close when someone clicks on the "x" symbol inside the overlay */
function hideLoadingIndicator() {
    $("#partsAddToCartLoadingIndicator").addClass("hide");
}

/* Open when someone clicks on the span element */
function showLoadingOverlay() {
  	hideViewCartLink();
    $("#partsAddToCartOverlay").width("100%");
}

/* Close when someone clicks on the "x" symbol inside the overlay */
function hideLoadingOverlay() {
    $("#partsAddToCartOverlay").width("0%");
}

function updateLoadingIndicatorMessage(message) {
  $("#partsAddToCartMessage").text(message);
}
  

function hideViewCartLink() {
  $("#partsViewCart").addClass('hide');
}

function showViewCartLink() {
  $("#partsViewCart").removeClass('hide');
}

function findProductBySku(sku, price, partInfo, qty) {
  
  //var url = '/apps/sku-lookup/' + sku + '.json';
  var url = '/search?type=product&q=variants.sku:' + sku + '&view=json';     //'/apps/sku-lookup/' + sku + '.json';
   
   $.ajax({
     url: url,

     type: "POST",

     dataType: "json",

     data: {"categories": partInfo, "price": price },

     /**
             * A function to be called if the request fails. 
             */
     error: function(jqXHR, textStatus, errorThrown) {
       //$('#result').html('<p>status code: '+jqXHR.status+'</p><p>errorThrown: ' + errorThrown + '</p><p>jqXHR.responseText:</p><div>'+jqXHR.responseText + '</div>');
       if (console && console.log) {
         console.log('errorThrown:', errorThrown);
       }
       hideLoadingOverlay();
       // TODO: error message 
     },

     /**
             * A function to be called if the request succeeds.
             */
     success: function(data, textStatus, jqXHR) {
       //$('#result').html(jqXHR.responseText);
       if (console && console.log) {
         console.log('data:', data);
       }

       if (data && data.results && data.results.length > 0 && data.results[0].Sku) {
         addProductToCart(data.results[0].current_variant_id, qty) 
       } else {
         hideLoadingIndicator();
         updateLoadingIndicatorMessage("This product is not currently available from the manufacturer.");

         window.setTimeout(function(){
           hideLoadingOverlay();
         }, 3000);                
       }

       var product = data.results 
       }
   });
}

function addProductToCart(current_variant_id, qty) {
  
	updateLoadingIndicatorMessage("Product found.  Adding to cart...");
  
    Shopify.addItem(current_variant_id, qty, function() {
      $(".site-header__cart-indicator").removeClass('hide');
		showViewCartLink();
      hideLoadingIndicator();
      updateLoadingIndicatorMessage("Success! We've added the part to your cart.");
      window.setTimeout(function(){

        hideLoadingOverlay();

      }, 3000);

    });
}